import React from "react";
import { Table } from "@sscs/ui";
import { AllowedTo } from "Components";
import { Permission } from "Constants";
import { Member } from "Types";
import GroupMemberActions from "./GroupMemberActions";
import OrgMemberActions from "./OrgMemberActions";

type MemberRowActionsProps = {
  member: Member;
  permissions: Permission[];
  groupId?: string;
};

const MemberRowActions = ({
  member,
  groupId,
  permissions,
}: MemberRowActionsProps): React.JSX.Element => {
  if (groupId) {
    return (
      <AllowedTo permissions={permissions} groupId={groupId}>
        <Table.Cell align="center">
          <GroupMemberActions member={member} groupId={groupId} />
        </Table.Cell>
      </AllowedTo>
    );
  } else {
    return (
      <AllowedTo permissions={permissions}>
        <Table.Cell align="center">
          <OrgMemberActions member={member} />
        </Table.Cell>
      </AllowedTo>
    );
  }
};

export default MemberRowActions;
